import React, { useState, useRef } from "react";
import "./carousel.css";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Mod1 from "./Images/Mod1.webp";
import Wed3 from "./Images/Wed3.webp";
import Wed23 from "./Images/Wed23.webp";
import Out2 from "./Images/Out2.webp";
import Out3 from "./Images/Out3.webp";
import Bab14 from "./Images/Bab14.webp";
import Mat5 from "./Images/Mat5.webp";
import Mat12 from "./Images/Mat12.webp";
import Mat7 from "./Images/Mat7.webp";
import Mod9 from "./Images/Mod9.webp";
import Mat1 from "./Images/Mat1.webp";


function MyCarousel() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const carouselRef = useRef(null);
  const touchStartX = useRef(0);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const touchEndX = e.changedTouches[0].clientX;
    const deltaX = touchEndX - touchStartX.current;

    if (deltaX > 50) {
      carouselRef.current.prev();
    } else if (deltaX < -50) {
      carouselRef.current.next();
    }
  };

  return (
    <div className="carousel-container">
      <Carousel
        autoPlay
        interval={2500}
        infiniteLoop
        showThumbs={false}
        showStatus={false}
        selectedItem={currentSlide}
        onChange={(index) => setCurrentSlide(index)}
        swipeable
        emulateTouch
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        ref={carouselRef}
        showIndicators={false}
      >
        <div><img src={Mod1} alt="Mod1" loading="lazy" /></div>
        <div><img src={Out3} alt="Out3" loading="lazy" /></div>
        <div><img src={Mat12} alt="Mat12" loading="lazy" /></div>
        <div><img src={Mod9} alt="Mod9" loading="lazy" /></div>
        <div><img src={Wed23} alt="Wed23" loading="lazy" /></div>
        <div><img src={Mat7} alt="Mat7" loading="lazy" /></div>
        <div><img src={Wed3} alt="Wed3" loading="lazy" /></div>
        <div><img src={Out2} alt="Out2" loading="lazy" /></div>
        <div><img src={Mat5} alt="Mat5" loading="lazy" /></div>
        <div><img src={Bab14} alt="Bab14" loading="lazy" /></div>
        <div><img src={Mat1} alt="Mat1" loading="lazy" /></div>
      </Carousel>
    </div>
  );
}

export default MyCarousel;